import { AlpineComponent } from '@alpinejs/csp';

const HeroesTopicState = (): AlpineComponent => ({
  visible: false,

  handleIntersect() {
    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'heroes-topic-stage--visible' : '';
  }
});

export default HeroesTopicState;
